module.exports = __webpack_public_path__ + "img/pokaluebersicht.88778400.png";